import type { OrderStatusId } from '@witmetrics/utils';
import SelectDropdown from '@/components/inputs/SelectDropdown';
import { STATUS_OPTIONS } from './constants';
import { getValue } from './utils';

export type StatusFieldProps = {
  className?: string;
  value: OrderStatusId;
  onSelect: (value: OrderStatusId) => void;
};

export default function StatusField({
  className,
  value,
  onSelect,
}: StatusFieldProps) {
  return (
    <SelectDropdown
      className={className}
      label="Order Status"
      value={getValue(value)}
      options={STATUS_OPTIONS}
      onChange={(update) => onSelect(update.value as OrderStatusId)}
    />
  );
}
